indexCtrl.$inject = ['$rootScope', '$location', '$window'];

function indexCtrl($rootScope, $location, $window) {
  if ($rootScope.auth && ($rootScope.auth.roles.clientPlus || $rootScope.auth.roles.customerService)) {
    $window.location = '/v2/distribution';
  } else {
    $window.location = '/v2/plans';
  }
}

module.exports = indexCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/indexCtrl.js
 ** module id = 129
 ** module chunks = 1
 **/